var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeatureActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11272",
    "data-name": "Path 11272",
    d: "M32.718,15.515a2.833,2.833,0,1,1,2.827-2.833,2.833,2.833,0,0,1-2.827,2.833Zm0-4.512a1.679,1.679,0,1,0,1.673,1.679A1.679,1.679,0,0,0,32.718,11Z",
    transform: "translate(-12.642 -4.167)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3760",
    "data-name": "Rectangle 3760",
    width: 13.529,
    height: 1.154,
    transform: "translate(2.596 7.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3761",
    "data-name": "Rectangle 3761",
    width: 5.077,
    height: 1.154,
    transform: "translate(22.327 7.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11273",
    "data-name": "Path 11273",
    d: "M15.123,26.265a2.833,2.833,0,1,1,2.833-2.833A2.833,2.833,0,0,1,15.123,26.265Zm0-4.512A1.679,1.679,0,1,0,16.8,23.433a1.679,1.679,0,0,0-1.679-1.679Z",
    transform: "translate(-5.2 -8.715)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3762",
    "data-name": "Rectangle 3762",
    width: 3.381,
    height: 1.154,
    transform: "translate(2.596 14.14)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3763",
    "data-name": "Rectangle 3763",
    width: 15.225,
    height: 1.154,
    transform: "translate(12.179 14.14)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11274",
    "data-name": "Path 11274",
    d: "M28.813,38a2.833,2.833,0,1,1,2.833-2.833A2.833,2.833,0,0,1,28.813,38Zm0-4.512a1.679,1.679,0,1,0,1.679,1.679A1.679,1.679,0,0,0,28.813,33.484Z",
    transform: "translate(-10.992 -13.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3764",
    "data-name": "Rectangle 3764",
    width: 11.279,
    height: 1.154,
    transform: "translate(2.596 20.908)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3765",
    "data-name": "Rectangle 3765",
    width: 7.327,
    height: 1.154,
    transform: "translate(20.077 20.908)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3766",
    "data-name": "Rectangle 3766",
    width: 30,
    height: 30,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureActive);
export default __webpack_public_path__ + "static/media/feature_active.c2777ebaa4ab8c5d06c4f0933ef18074.svg";
export { ForwardRef as ReactComponent };